import { get } from 'lodash-es';
import { actions, selectors } from '../../../state';

export function PhoneVerificationDirective($q, updStore) {
  'ngInject';
  const { connect, dispatch } = updStore;

  return {
    restrict: 'A',
    require: 'ngModel',
    link,
    scope: {
      maxLength: '@',
      verifying: '=verifyingPhone',
      verify: '&updPhoneVerification',
    },
  };

  function link(scope, element, attrs, ctrl) {
    const disconnect = connect(mapStateToScope)(scope);
    scope.$on('$destroy', disconnect);

    const isCompleteNumber = value =>
      (value || '').length === Number(scope.maxLength);

    ctrl.$asyncValidators.phoneVerification = (modelValue, viewValue) => {
      const value = modelValue || viewValue;

      function success(response) {
        const deliveryMethods = get(response, 'payload.delivery_methods');
        const verifiedPhone = value;

        scope.verify({ $value: { deliveryMethods, verifiedPhone } });
        dispatch(actions.analytics.track('Validated Phone Number'));
      }

      function error(response) {
        const errors = get(response, 'payload.errors');
        scope.verify({ $value: { errors } });
        dispatch(
          actions.analytics.track('Tried Validating Phone Number', {
            Errors: errors,
          })
        );
        return $q.reject(errors);
      }

      if (value && isCompleteNumber(value) && !scope.verifying) {
        dispatch(actions.analytics.track('Entered Verify Phone Number'));

        return dispatch(
          actions.phoneVerification.create({
            move_id: scope.moveId,
            phone_number: value,
          })
        ).then(success, error);
      } else {
        return $q.resolve(true);
      }
    };
  }
}

function mapStateToScope(state) {
  return {
    moveId: selectors.current.move(state).id(state),
    verifying: selectors.pending.match(
      actions.phoneVerification.isCreate,
      state
    ),
  };
}
